module.exports = __webpack_public_path__ + "img/XKX.16ff01ed.svg";